// assets/mobile-menu.js
document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuButton = document.getElementById('lnk-mobile-menu');
    const mobileSearchMenuButton = document.getElementById('lnk-mobile-search-menu');

    const navItem = document.querySelector('.header__inline-menu');
    const notificationSection  =  document.querySelector('.notification-bar');
    const mobMenuItemOne  =  document.querySelector('#Details-HeaderMenu-1 div.header__menu-item span.header_menu-item-text');
    const headerMenu = document.querySelector(
        '.shopify-section.shopify-section-group-header-group.section-header'
    );
    const megaMenu = document.querySelector(
        '.mega-menu__content.gradient.motion-reduce.global-settings-popup'
    );

    if (mobileMenuButton) {
        mobileMenuButton.addEventListener('click', function(event) {
            event.preventDefault();

            // Find the mobile menu container and toggle its visibility
            const mobileMenu = document.querySelector('.mobile-menu.header__menu-item');

            if (notificationSection) {
                notificationSection.style.display = 'none';
            }

            if (mobMenuItemOne) {
                // mobMenuItemOne.style.opacity = '1';
                // [workaround – item 15] Programmatically clicks the first nav item's span to trigger
                // the mega menu open state on mobile. This is intentional — we added this to pre-open
                // the first menu so it's visible when the drawer slides in. Fragile: relies on the
                // first nav item having a click handler. If the nav structure changes, revisit this.
                mobMenuItemOne.click();
            }

            // Disable body scroll when menu opens
            document.body.style.overflow = 'hidden';

            if(headerMenu){
                headerMenu.classList.toggle('header--sticky-full');
            }

            if(megaMenu){
                megaMenu.classList.toggle('mega-menu--scrollable');
            }

            if (mobileMenu) {
                mobileMenu.classList.toggle('is-active');

                // Toggle visibility of specified elements
                document.querySelectorAll('.header__icons, .mobile-menu.header__menu-item, .header__heading').forEach(el => {
                    el.classList.toggle('hidden');
                });

                document.querySelectorAll('.list-menu.list-menu--inline').forEach(el => {
                    el.classList.toggle('show');
                });

                //Show close button
                const menuClose = document.querySelector('.header-menu-close');
                menuClose.classList.toggle('show')
                // Optional: toggle aria-expanded for accessibility
                const expanded = this.getAttribute('aria-expanded') === 'true' || false;
                this.setAttribute('aria-expanded', !expanded);
                navItem.classList.toggle('menu-open');
            }
        });

        // TODO [audit item 20] No Escape key handler — pressing Escape while the menu is open
        // does nothing. Should trigger the same close logic below (remove classes, re-enable scroll).
        const mobileCloseMenuButton = document.getElementById('lnk-mobile-close-menu');
        if (mobileCloseMenuButton) {
            mobileCloseMenuButton.addEventListener('click', function(event) {
                event.preventDefault();

                if (notificationSection) {
                    notificationSection.style.display = 'unset';
                }

                // Re-enable body scroll when menu closes
                document.body.style.overflow = '';

                if(headerMenu){
                    headerMenu.classList.remove('header--sticky-full');
                }

                if(megaMenu){
                    megaMenu.classList.remove('mega-menu--scrollable');
                }

                // Find the mobile menu container and toggle its visibility
                const menuClose = document.querySelector('.header-menu-close')
                if (menuClose) {
                    // mobileMenu.classList.toggle('is-active');

                    document.querySelectorAll('.header__icons, .mobile-menu.header__menu-item, .header__heading').forEach(el => {
                        el.classList.remove('hidden');
                    });

                    document.querySelectorAll('.list-menu.list-menu--inline').forEach(el => {
                        el.classList.remove('show');
                    });

                    //Show close button
                    const menuClose = document.querySelector('.header-menu-close');
                    menuClose.classList.remove('show');
                    menuClose.classList.toggle('hidden');
                    navItem.classList.remove('menu-open');
                }
            });
        }

    }

    if (mobileSearchMenuButton) {
        const mobileSearchMenu = document.querySelector('.mobile-search-menu');
        const mobileSearchClose = document.querySelector('.mobile-search-menu__close');
        const mobileSearchInput = document.getElementById('Mobile-Search-Input');

        mobileSearchMenuButton.addEventListener('click', function(event) {
            event.preventDefault();

            // Open the mobile search menu
            if (mobileSearchMenu) {
                mobileSearchMenu.style.display = '';
                mobileSearchMenu.classList.add('is-open');
                document.body.style.overflow = 'hidden';

                // Focus on search input
                if (mobileSearchInput) {
                    setTimeout(() => {
                        mobileSearchInput.focus();
                    }, 300);
                }
            }
        });

        // Close button handler
        if (mobileSearchClose) {
            mobileSearchClose.addEventListener('click', function(event) {
                event.preventDefault();

                if (mobileSearchMenu) {
                    mobileSearchMenu.classList.remove('is-open');
                    document.body.style.overflow = '';

                    // Clear search input
                    if (mobileSearchInput) {
                        mobileSearchInput.value = '';
                    }
                }
            });
        }
    }

    const detailsElements = document.querySelectorAll('.tree-menu-details, .tree-submenu-details');
    if (detailsElements) {
        detailsElements.forEach(details => {
            details.addEventListener('toggle', () => {
                const parent = details.closest('li');
                if (details.open) {
                    parent.classList.add('expanded');
                } else {
                    parent.classList.remove('expanded');
                }
            });
        });
    }

    // Fix mobile search related bugs
    function closeMobileSearchDrawer() {
        const mobileMenu = document.querySelector(".mobile-search-menu");
        if (mobileMenu && mobileMenu.classList.contains("is-open")) {
            mobileMenu.classList.remove("is-open");
            mobileMenu.style.display = "none";
            document.body.style.overflow = "";
        }
    }

    function closeMobileSearchOnEnter(e) {
        if (e.key !== "Enter") return;

        const input = e.target;
        if (!input || input.id !== "Mobile-Search-Input") return;

        closeMobileSearchDrawer();

        // IMPORTANT: do NOT prevent default
    }

    document.addEventListener("keydown", closeMobileSearchOnEnter, true);

    // Close drawer when user clicks a Nosto suggestion in the mobile drawer
    document.addEventListener(
        "click",
        (e) => {
            // only if click happened inside the open mobile drawer
            if (!e.target.closest(".mobile-search-menu.is-open")) return;

            const nostoSuggestion = e.target.closest(".ns-autocomplete-element");

            if (nostoSuggestion) closeMobileSearchDrawer();
        },
        true
    );

});